/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * ClientsApi - axios parameter creator
 * @export
 */
export const ClientsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new client.
         * @param {CreateClientDto} createClientDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerCreate: (createClientDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createClientDto' is not null or undefined
            assertParamExists('clientControllerCreate', 'createClientDto', createClientDto);
            const localVarPath = `/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createClientDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all clients for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindAll: (workspaceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('clientControllerFindAll', 'workspaceId', workspaceId);
            const localVarPath = `/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all clients for a workspace with pagination.
         * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
         * @param {Array<string>} [clientIds] Filter clients whose id is in the provided list.
         * @param {string} [clientName] Case-insensitive substring match against clientName and workspaceName (kept for backwards compatibility; prefer &#x60;searchTerm&#x60;).
         * @param {string} [clientReferenceId] Exact match against the externally-supplied reference id.
         * @param {string} [representationEndDateFrom] Lower bound for representationEndDate. Use with representationEndDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
         * @param {string} [representationEndDateTo] Upper bound for representationEndDate. Use with representationEndDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
         * @param {string} [representationStartDateFrom] Lower bound for representationStartDate. Use with representationStartDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
         * @param {string} [representationStartDateTo] Upper bound for representationStartDate. Use with representationStartDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
         * @param {ClientRepresentationStatusEnum} [representationStatus] Filter by the client representation status.
         * @param {Array<ClientRepresentationStatusEnum>} [representationStatuses] Filter by one or more client representation statuses. Repeatable or comma-separated. Takes precedence over representationStatus when both are sent.
         * @param {string} [searchTerm] Broad search term matched against clientName, workspaceName, clientReferenceId, and shortId using OR logic when no other search params are provided.
         * @param {string} [shortId] Exact match against the generated short id (e.g. &#x60;P1000000&#x60;).
         * @param {string} [workspaceId] Restrict the search to a single workspace.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindAllV2: (allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (allowPayments !== undefined) {
                localVarQueryParameter['allowPayments'] = allowPayments;
            }
            if (clientIds) {
                localVarQueryParameter['clientIds'] = clientIds;
            }
            if (clientName !== undefined) {
                localVarQueryParameter['clientName'] = clientName;
            }
            if (clientReferenceId !== undefined) {
                localVarQueryParameter['clientReferenceId'] = clientReferenceId;
            }
            if (representationEndDateFrom !== undefined) {
                localVarQueryParameter['representationEndDateFrom'] =
                    representationEndDateFrom;
            }
            if (representationEndDateTo !== undefined) {
                localVarQueryParameter['representationEndDateTo'] =
                    representationEndDateTo;
            }
            if (representationStartDateFrom !== undefined) {
                localVarQueryParameter['representationStartDateFrom'] =
                    representationStartDateFrom;
            }
            if (representationStartDateTo !== undefined) {
                localVarQueryParameter['representationStartDateTo'] =
                    representationStartDateTo;
            }
            if (representationStatus !== undefined) {
                localVarQueryParameter['representationStatus'] = representationStatus;
            }
            if (representationStatuses) {
                localVarQueryParameter['representationStatuses'] =
                    representationStatuses;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (shortId !== undefined) {
                localVarQueryParameter['shortId'] = shortId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get client by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientControllerFindOne', 'id', id);
            const localVarPath = `/client/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a client by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientControllerRemove', 'id', id);
            const localVarPath = `/client/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing client.
         * @param {string} id
         * @param {UpdateClientDto} updateClientDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerUpdate: (id, updateClientDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientControllerUpdate', 'id', id);
            // verify required parameter 'updateClientDto' is not null or undefined
            assertParamExists('clientControllerUpdate', 'updateClientDto', updateClientDto);
            const localVarPath = `/client/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set allowPayments on a client (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
         * @param {string} id
         * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerUpdateAllowPayments: (id, updateAllowPaymentsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientControllerUpdateAllowPayments', 'id', id);
            // verify required parameter 'updateAllowPaymentsDto' is not null or undefined
            assertParamExists('clientControllerUpdateAllowPayments', 'updateAllowPaymentsDto', updateAllowPaymentsDto);
            const localVarPath = `/client/{id}/allow-payments`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllowPaymentsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClientsApi - functional programming interface
 * @export
 */
export const ClientsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClientsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new client.
         * @param {CreateClientDto} createClientDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerCreate(createClientDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerCreate(createClientDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all clients for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindAll(workspaceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerFindAll(workspaceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all clients for a workspace with pagination.
         * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
         * @param {Array<string>} [clientIds] Filter clients whose id is in the provided list.
         * @param {string} [clientName] Case-insensitive substring match against clientName and workspaceName (kept for backwards compatibility; prefer &#x60;searchTerm&#x60;).
         * @param {string} [clientReferenceId] Exact match against the externally-supplied reference id.
         * @param {string} [representationEndDateFrom] Lower bound for representationEndDate. Use with representationEndDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
         * @param {string} [representationEndDateTo] Upper bound for representationEndDate. Use with representationEndDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
         * @param {string} [representationStartDateFrom] Lower bound for representationStartDate. Use with representationStartDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
         * @param {string} [representationStartDateTo] Upper bound for representationStartDate. Use with representationStartDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
         * @param {ClientRepresentationStatusEnum} [representationStatus] Filter by the client representation status.
         * @param {Array<ClientRepresentationStatusEnum>} [representationStatuses] Filter by one or more client representation statuses. Repeatable or comma-separated. Takes precedence over representationStatus when both are sent.
         * @param {string} [searchTerm] Broad search term matched against clientName, workspaceName, clientReferenceId, and shortId using OR logic when no other search params are provided.
         * @param {string} [shortId] Exact match against the generated short id (e.g. &#x60;P1000000&#x60;).
         * @param {string} [workspaceId] Restrict the search to a single workspace.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindAllV2(allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerFindAllV2(allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get client by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a client by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing client.
         * @param {string} id
         * @param {UpdateClientDto} updateClientDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerUpdate(id, updateClientDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerUpdate(id, updateClientDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set allowPayments on a client (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
         * @param {string} id
         * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClientsApi - factory interface
 * @export
 */
export const ClientsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClientsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new client.
         * @param {CreateClientDto} createClientDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerCreate(createClientDto, options) {
            return localVarFp
                .clientControllerCreate(createClientDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all clients for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindAll(workspaceId, options) {
            return localVarFp
                .clientControllerFindAll(workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all clients for a workspace with pagination.
         * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
         * @param {Array<string>} [clientIds] Filter clients whose id is in the provided list.
         * @param {string} [clientName] Case-insensitive substring match against clientName and workspaceName (kept for backwards compatibility; prefer &#x60;searchTerm&#x60;).
         * @param {string} [clientReferenceId] Exact match against the externally-supplied reference id.
         * @param {string} [representationEndDateFrom] Lower bound for representationEndDate. Use with representationEndDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
         * @param {string} [representationEndDateTo] Upper bound for representationEndDate. Use with representationEndDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
         * @param {string} [representationStartDateFrom] Lower bound for representationStartDate. Use with representationStartDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
         * @param {string} [representationStartDateTo] Upper bound for representationStartDate. Use with representationStartDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
         * @param {ClientRepresentationStatusEnum} [representationStatus] Filter by the client representation status.
         * @param {Array<ClientRepresentationStatusEnum>} [representationStatuses] Filter by one or more client representation statuses. Repeatable or comma-separated. Takes precedence over representationStatus when both are sent.
         * @param {string} [searchTerm] Broad search term matched against clientName, workspaceName, clientReferenceId, and shortId using OR logic when no other search params are provided.
         * @param {string} [shortId] Exact match against the generated short id (e.g. &#x60;P1000000&#x60;).
         * @param {string} [workspaceId] Restrict the search to a single workspace.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindAllV2(allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options) {
            return localVarFp
                .clientControllerFindAllV2(allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get client by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerFindOne(id, options) {
            return localVarFp
                .clientControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a client by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerRemove(id, options) {
            return localVarFp
                .clientControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing client.
         * @param {string} id
         * @param {UpdateClientDto} updateClientDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerUpdate(id, updateClientDto, options) {
            return localVarFp
                .clientControllerUpdate(id, updateClientDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set allowPayments on a client (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
         * @param {string} id
         * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options) {
            return localVarFp
                .clientControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClientsApi - object-oriented interface
 * @export
 * @class ClientsApi
 * @extends {BaseAPI}
 */
export class ClientsApi extends BaseAPI {
    /**
     *
     * @summary Create a new client.
     * @param {CreateClientDto} createClientDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerCreate(createClientDto, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerCreate(createClientDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all clients for a workspace.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerFindAll(workspaceId, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerFindAll(workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all clients for a workspace with pagination.
     * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
     * @param {Array<string>} [clientIds] Filter clients whose id is in the provided list.
     * @param {string} [clientName] Case-insensitive substring match against clientName and workspaceName (kept for backwards compatibility; prefer &#x60;searchTerm&#x60;).
     * @param {string} [clientReferenceId] Exact match against the externally-supplied reference id.
     * @param {string} [representationEndDateFrom] Lower bound for representationEndDate. Use with representationEndDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
     * @param {string} [representationEndDateTo] Upper bound for representationEndDate. Use with representationEndDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
     * @param {string} [representationStartDateFrom] Lower bound for representationStartDate. Use with representationStartDateTo. Calendar dates (YYYY-MM-DD) are interpreted as UTC day starts; full ISO datetimes are inclusive instants.
     * @param {string} [representationStartDateTo] Upper bound for representationStartDate. Use with representationStartDateFrom. Calendar dates (YYYY-MM-DD) include that entire UTC day; full ISO datetimes are inclusive instants.
     * @param {ClientRepresentationStatusEnum} [representationStatus] Filter by the client representation status.
     * @param {Array<ClientRepresentationStatusEnum>} [representationStatuses] Filter by one or more client representation statuses. Repeatable or comma-separated. Takes precedence over representationStatus when both are sent.
     * @param {string} [searchTerm] Broad search term matched against clientName, workspaceName, clientReferenceId, and shortId using OR logic when no other search params are provided.
     * @param {string} [shortId] Exact match against the generated short id (e.g. &#x60;P1000000&#x60;).
     * @param {string} [workspaceId] Restrict the search to a single workspace.
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerFindAllV2(allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerFindAllV2(allowPayments, clientIds, clientName, clientReferenceId, representationEndDateFrom, representationEndDateTo, representationStartDateFrom, representationStartDateTo, representationStatus, representationStatuses, searchTerm, shortId, workspaceId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get client by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerFindOne(id, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a client by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerRemove(id, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing client.
     * @param {string} id
     * @param {UpdateClientDto} updateClientDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerUpdate(id, updateClientDto, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerUpdate(id, updateClientDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set allowPayments on a client (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
     * @param {string} id
     * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    clientControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options) {
        return ClientsApiFp(this.configuration)
            .clientControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
